
const isRTK = (siteReport) => {
  if (siteReport?.locatorModel?.toLowerCase() === 'rtk-mapper') return true;
  if (siteReport?.locatorModel?.toLowerCase() === 'vlocate mapper') return true;
  return false;
};

export default isRTK;
